<template>
  <div id="app">
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container>
      <Header />
      <div v-if="clientAccessLoginPanel">
        <v-row>
          <v-col :cols="7">
            <v-row justify="center" align="center">
              <v-col>
                <img src="/assets/img/fgraphicHeart.png" />
              </v-col>
              <v-col>
                <img src="/assets/img/fgraphicApple.png" />
              </v-col>
              <v-col>
                <img src="/assets/img/fgraphicSteth.png" />
              </v-col>
            </v-row>
            <v-row justify="center" align="center">
              <v-col>
                <img src="/assets/img/fgraphicSpine.png" />
              </v-col>
              <v-col>
                <img src="/assets/img/fgraphicMind.png" />
              </v-col>
              <v-col>
                <img src="/assets/img/fgraphicWalk.png" />
              </v-col>
            </v-row>
          </v-col>

          <v-col :cols="5">
            <v-card class="mx-auto entercodebox" flat color="transparent">
              <v-card-text>
                <p class="display-1">Enter Password</p>

                <v-alert
                  type="error"
                  class="mt-5"
                  v-if="showPasswordInvalidMessage"
                  dense
                  >Password is incorrect.</v-alert
                >

                <v-text-field
                  v-model="password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  name="input-10-2"
                  label="Client area password"
                  value="wqfasds"
                  class="entercodeboxinput"
                  outlined
                  @click:append="showPassword = !showPassword"
                ></v-text-field>

                <v-btn
                  @click="submitPassword"
                  depressed
                  large
                  color="primary"
                  block
                  class="hp--btn"
                  >SUBMIT</v-btn
                >
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div v-if="clientAccessLoginErrorPanel">
        <v-card class="mx-auto" max-width="400">
          <v-toolbar flat>
            <v-toolbar-title class="black--text">Oops...</v-toolbar-title>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-text>
            <p class="darkgrey--text text-center">We can't find your event!</p>
            <p class="text-center ma-2">
              If you need to get in touch,
              <a href="#" style="color: green"> click here. </a>
            </p>
          </v-card-text>
        </v-card>
      </div>
      <EventBooking :eventData="events" v-if="events !== null" />
      <Footer />
    </v-container>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import EventBooking from "../components/BookingsByEvent.vue";
import { ClientAccess } from "../classes/ClientAccess";
import { Event } from "../classes/Event";

export default {
  components: {
    Header,
    Footer,
    EventBooking,
  },
  data() {
    return {
      clientAccessLoginPanel: false,
      clientAccessLoginErrorPanel: false,
      password: "",
      showPasswordInvalidMessage: false,
      showPassword: false,
      events: null,
      nextToken: null,
      loader: false
    };
  },
  async created() {
    let events = await this.nextRecord();

    while (this.nextToken !== null) {
      let nextEvents = await this.nextRecord();
      events.push(...nextEvents);
    }
    if (events) {
      this.clientAccessLoginPanel = true;
    } else {
      this.clientAccessLoginErrorPanel = true;
    }
  },
  methods: {
    async nextRecord() {
      const clientAccess = await new ClientAccess().getClientAccessByClientAccessId(
        this.$route.params.eventId,
        this.nextToken
      );
      this.nextToken = clientAccess.nextToken;
      return clientAccess.items;
    },
    async submitPassword() {
      const isAuthenticated = await new ClientAccess().authenticateClient(
        this.$route.params.eventId,
        this.password
      );

      if (isAuthenticated) {
        this.getEventDetails();
      } else {
        this.clientAccessLoginPanel = true;
        this.clientAccessLoginErrorPanel = false;
        this.showPasswordInvalidMessage = true;
      }
    },
    async getEventDetails() {
      this.loader = true;
      let events = await new Event().getEventsById(
        this.$route.params.eventId,
        null
      );
      let eventItems = events.items;
      while (events.nextToken !== null) {
        events = await new Event().getEventsById(
          this.$route.params.eventId,
          events.nextToken
        );
        if (events.items.length > 0) {
          eventItems.push(...events.items);
        }
      }
      this.$route.params.eventId;
      this.clientAccessLoginPanel = false;
      this.clientAccessLoginErrorPanel = false;

      this.events = [];
      this.events = eventItems;
      this.loader = false;
    }
  }
};
</script>
